import request from '@/util/request'
import qs from 'qs'

export const getValidataImage = (UUID) => {
  return process.env.baseUrl + '/api-uaa/validata/code/' + UUID;
}

export function login(){
  return null
}

export function loginByMobile(data, headers) {
  return request({
    url: '/api-uaa/oauth/user/token',
    method: 'post',
    data:qs.stringify(data),
    headers:headers
  })
}

export function tylogin(data) {
  return request({
    url: '/api-user/thirdlogion/doTyLogin?' + qs.stringify(data),
    method: 'get'
  })
}

export function loginByEmail(data, headers) {
  return request({
    url: '/api-uaa/oauth/email/token',
    method: 'post',
    data:qs.stringify(data),
    headers:headers
  })
}

export function loginByOpenId(openId, headers) {
  console.log(headers)
  return request({
    url: '/api-uaa/oauth/openId/token?openId=' + openId,
    method: 'post',
    headers:headers
  })
}

export function loginByTicket(openId, headers) {
  console.log(headers)
  return request({
    url: '/api-uaa/oauth/srsc/token?ticket=' + openId,
    method: 'post',
    headers:headers
  })
}

export function refreshToken(token) {
  return request({
    url: '/api-uaa/oauth/token?grant_type=refresh_token&refresh_token=' + token,
    method: 'post'
  })
}

export function getInfo(token) {
  return request({
    url: '/api-uaa/info',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/api-uaa/oauth/remove/token',
    method: 'post'
  })
}

// 查询用户列表 不绑定用户角色
export function findUserList(data){
  return request({
    url: '/api-user/user/list?' + qs.stringify(data),
    method: 'get'
  })
}

//获取当前登录用户的详细信息
export function getCurrentUser() {
  return request({
    url: '/api-user/users/common/current',
    method: 'get'
  })
}

//注册获取验证码
export function getRegValidataCode(mobile) {
  return request({
    url: '/api-user/sms/register/' + mobile,
    method: 'get'
  })
}

//用户注册
export function registerUser(data) {
  return request({
    url: '/api-user/user/register',
    method: 'post',
    data:data  
  })
}


//获取当前登录用户所属的机构id
export function getCurrentUserOrgId(userid) {
  return request({
    url: '/api-orga/orgamember/findOrgaIdByUserId/' + userid,
    method: 'get'
  })
}

//获取当前登录用户信息
export function findLoginUserInfo(userid) {
  return request({
    url: '/api-user/user/findLoginUserInfo',
    method: 'get'
  })
}

// 根据userId 查询用户信息
export function findUserInfo(userid) {
  return request({
    url: '/api-user/user/findUserInfo/' + userid,
    method: 'get'
  })
}

export function toLoginPage(){
  window.location.href= '/login?fromUrl=' + encodeURIComponent(window.location.href);
  // router.push({
  //   name: 'Login',
  //   query : {
  //     "fromUrl" : window.location.href
  //   }
  // }); 
}

// 修改用户手机号码
export function userBindMobile(data){
  return request({
    url: '/api-user/user/bind/mobile',
    method: 'post',
    data:data  
  })
}

// 禅城区非遗平台oauth登录
export function ccihLoginTicket(ticket) {
  return request({
    url: '/api-uaa/oauth/ccih/login?ticket=' + ticket,
    method: 'post'
  })
}

// 获取微信登录地址
export function getWxAuthorizeUrl(fromUrl){
  return request({
    url: '/api-uaa/oauth/wx/pc/getAuthorize?fromUrl=' + fromUrl,
    method: 'get'
  })
}

// 微信登录
export function wxAuthorizeLogin(code){
  return request({
    url: '/api-uaa/oauth/wx/pc/token?code=' + code,
    method: 'post'
  })
}

// 完善用户信息
export function perfectUserinfo(data){
  return request({
    url: '/api-user/user/perfect/userinfo',
    method: 'post',
    data: data
  })
}

// 校验用户手机号码是否已被使用
export function checkUserPhone(phone){
  return request({
    url: '/api-user/check/phone/' + phone,
    method: 'get'
  })
}

// 修改用户信息
export function userModify(data) {
  return request({
    url: '/api-user/user/modify',
    method: 'post',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/user.js